export default __webpack_public_path__ + "static/media/icon_1.0da2011a.png";